import type { ISignInPushDevice } from '../../features/auth/api/auth-api';
import {
  LocalStorageKey,
  LocalStorageService,
} from '../../shared/storage/local-storage';
import { getPushDevicePlatform } from './push-platform';

export function getSignInPushDevicePayload(): ISignInPushDevice | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const raw = LocalStorageService.getValue(LocalStorageKey.pushFcmToken);
  const token = typeof raw === 'string' ? raw.trim() : '';
  if (!token) {
    return undefined;
  }
  return {
    fcmToken: token,
    platform: getPushDevicePlatform(),
  };
}
